import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollLockService {
  private lockCount = 0;
  private scrollY = 0;
  private previousStyles: Partial<CSSStyleDeclaration> | null = null;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  lock(): void {
    if (this.lockCount === 0) {
      const body = this.document.body;
      const docEl = this.document.documentElement;

      this.scrollY = window.scrollY || docEl.scrollTop || body.scrollTop || 0;
      this.previousStyles = {
        position: body.style.position,
        top: body.style.top,
        width: body.style.width,
        overflow: body.style.overflow,
        overscrollBehavior: body.style.overscrollBehavior,
      };

      body.style.position = 'fixed';
      body.style.top = `-${this.scrollY}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      body.style.overscrollBehavior = 'contain';
    }

    this.lockCount += 1;
  }

  unlock(): void {
    if (this.lockCount === 0) {
      return;
    }

    this.lockCount -= 1;
    if (this.lockCount === 0) {
      const body = this.document.body;
      const prev = this.previousStyles;

      if (prev) {
        body.style.position = prev.position || '';
        body.style.top = prev.top || '';
        body.style.width = prev.width || '';
        body.style.overflow = prev.overflow || '';
        body.style.overscrollBehavior = prev.overscrollBehavior || '';
      } else {
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        body.style.overflow = '';
        body.style.overscrollBehavior = '';
      }

      window.scrollTo(0, this.scrollY);
      this.previousStyles = null;
    }
  }
}
